'use strict';

app.controller('MessengerCtrl', [
    '$scope',
    'SocketIOManager',
    '$http',
    '$ngConfirm',
    '$translate',
    function($scope, SocketIOManager, $http, $ngConfirm, $translate) {
        let socket = null;

        $scope.form = {
            id: null,
            content: '',
        };

        $scope.nick = null;
        $scope.receivers = [];

        $scope.init = function() {
            socket = SocketIOManager.get();

            console.log('emit: server:receivers');

            socket.emit('server:receivers', (response) => {
                console.log('acknowledgements: server:receivers:', response);

                $scope.receivers = response.receivers;
                $scope.$apply();
            });

            getUserDocuments();
        };

        const getUserDocuments = () => {
            const endpoint = '/rest-api/ms/driver/api/messenger/documents';

            return $http.get(endpoint).then((response) => {
                $scope.documents = response.data;
            });
        };

        const uploadDocument = (content) => {
            const endpoint = '/rest-api/ms/driver/api/messenger/document';

            return $http.post(endpoint, { content });
        };

        const deleteDocument = (id) => {
            const endpoint = `/rest-api/ms/driver/api/messenger/document/${id}`;

            return $http.delete(endpoint);
        };

        $scope.rename = function(receiver) {
            const $isolated = $scope.$new(true);
            const { Account } = receiver;

            $isolated.data = {
                id: Account.id,
                name: Account.account.name,
            };

            $ngConfirm({
                title: 'Edycja',
                contentUrl: 'tpl/pages/messenger/modals/rename.html',
                theme: 'supervan',
                columnClass: 'xl',
                icon: 'fas fa-pen',
                scope: $isolated,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.save.ok'),
                        btnClass: 'btn-success',
                        action: function(scope) {
                            const { id, name } = scope.data;

                            console.log('emit: server:receiver:rename', { id, name });

                            socket.emit('server:receiver:rename', { id, name }, () => {});

                            return true;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-info',
                    },
                },
            });
        };

        $scope.load = () => {
            angular.element('#input-messenger-file').trigger('click');
        };

        angular.element('#input-messenger-file').change(function(e) {
            const data = e.originalEvent.target.files[0];
            const reader = new FileReader();

            reader.onload = function(event) {
                const msg = {};

                msg.file = event.target.result;
                msg.filename = data.name;

                $scope.form.image = msg;

                $ngConfirm({
                    title: 'Messenger',
                    contentUrl: 'tpl/pages/messenger/modals/preview.html',
                    theme: 'supervan',
                    columnClass: 'xl',
                    icon: 'fas fa-camera',
                    scope: $scope,
                    buttons: {
                        yes: {
                            text: $translate.instant('general.confirm.save.ok'),
                            btnClass: 'btn-success',
                            action: function(scope) {
                                const content = scope.form.image.file;

                                console.log('rest-api: get user documents', { content });

                                uploadDocument(content).then(getUserDocuments);

                                $scope.form.image = '';
                                $scope.$apply();

                                return true;
                            },
                        },
                        no: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-info',
                        },
                    },
                });
            };

            reader.readAsDataURL(this.files[0]);
        });

        let isTyping = false;
        let timeout = undefined;

        function stopTyping(id) {
            isTyping = false;

            console.log('emit: server:typing:', { id, isTyping });

            socket.emit('server:typing', { id, isTyping });
        }

        angular.element('#input-messenger-text').keypress((e) => {
            const { id } = $scope.form;

            if (!id) {
                return;
            }

            if (e.which !== 13) {
                isTyping = true;

                console.log('emit: server:typing:', { id, isTyping });

                socket.emit('server:typing', { id, isTyping });

                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    stopTyping(id);
                }, 3000);
            } else {
                console.log('angular: text: send:');

                clearTimeout(timeout);
                stopTyping(id);

                $scope.send();
            }
        });

        $scope.send = function() {
            const { id, content } = $scope.form;

            if (!id || !content) {
                return;
            }

            console.log('emit: server:message', { id, content });

            socket.emit('server:message', { id, content }, (response) => {
                console.log('acknowledgements: server:message:', response);
            });

            $scope.form.content = '';
        };

        $scope.attach = function(document) {
            const { id } = $scope.form;
            const content = '';

            if (!id || !document) {
                return;
            }

            console.log('emit: server:message', { id, content, document });

            socket.emit('server:message', { id, content, document }, (response) => {
                console.log('acknowledgements: server:message:', response);
            });

            $scope.form.content = '';
        };

        $scope.delete = function(document) {
            deleteDocument(document).then(getUserDocuments);
        }

        $scope.change = function() {
            const { id } = $scope.form;

            console.log('emit: server:messages', { id });

            socket.emit('server:messages', { id }, (response) => {
                console.log('acknowledgements: server:messages:', response);

                $scope.messages = response.messages;
                $scope.$apply();
            });
        };

        $scope.init();

        /**
         * @sockets - on
         */

        socket.on('client:typing', (response) => {
            console.log('on: client:typing:', response);

            const receiver = $scope.receivers.find((o) => o.Account.id === response.id);

            if (receiver) {
                receiver.isTyping = response.isTyping;

                $scope.$apply();
            }
        });

        socket.on('client:message', (response) => {
            console.log('on: client:message:', response);

            $scope.messages = $scope.messages.concat(response.messages);
            $scope.$apply();
        });

        socket.on('client:receivers:update', () => {
            console.log('on: client:receivers:update:');
            console.log('emit: server:receivers');

            socket.emit('server:receivers', (response) => {
                console.log('acknowledgements: server:receivers:', response);

                $scope.receivers = response.receivers;
                $scope.$apply();
            });
        });

        /**
         * @sockets - reserved
         */

        socket.on('disconnect', (reason) => {
            console.log('on: disconnect:', { reason });
        });

        socket.on('connect_error', (err) => {
            console.log('on: connect_error:', err.message);
        });

        socket.on('error:client', (data) => {
            console.log('on: error:client:', { data });
        });
    },
]);
